import { useEffect, useState } from 'react';
import globalPageStyle from '../css/globalPage.module.scss';
import { LogsObject } from '../helpers/objects/logsObject';
import axios from 'axios';
import { EnvPaths } from '../helpers/environment';
import styles from '../css/logsPage.module.scss';
import { useAuth } from '../context/AuthContext';
import tableStyles from '../css/table.module.scss';
import Pagination from '../components/pagination';
import CustomSearchInput from '../components/customSearchInput';
import { useTranslation } from 'react-i18next';

const LogsPage = () => {
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [loading, setLoading] = useState(true);
  const [logsList, setLogsList] = useState<LogsObject[]>([]);
  const [page, setPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const { user } = useAuth();
  const { t } = useTranslation();

  const handleSearch = (value: string) => {
    setSearchTerm(value);
  };

  const fetchLogs = async () => {
    try {
      const response = await axios.get(`${EnvPaths.SERVER_URL}/admin/get-logs?page=${page}`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      });
      const { logs, totalPages } = response.data;
      setLogsList(logs);
      setTotalPages(totalPages);
      return logs;
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      if (user) {
        fetchLogs().then((response) => {
          setLogsList(response ?? []);
          setLoading(false);
        });
      }
    }, 1000);
  }, [page, user]);

  const onPrevious = () => {
    setPage(page - 1);
  };

  const onNext = () => {
    setPage(page + 1);
  };

  return (
    <main className={globalPageStyle.pageContainer}>
      <div className={globalPageStyle.pageContent}>
        {user && user?.role === 'admin' ? (
          loading ? (
            <div className="loader" />
          ) : logsList.length > 0 ? (
            <div className={styles.body}>
              <div className={styles.logsContainer}>
                {/*filters*/}
                {/* <div className={styles.flexRow}>
                  <CustomSearchInput onSearch={handleSearch} icon="/assets/images/search-icon.svg" placeholder="Search" />
                </div> */}
                {/*filters*/}
                {/*Table*/}
                <div className={tableStyles.tableContainer}>
                  <table className={`${tableStyles.table}`}>
                    <thead className={tableStyles.tableHeader}>
                      <tr>
                        <th>{t('logs.createdAt')}</th>
                        <th>{t('logs.summary')}</th>
                        <th>{t('logs.details')}</th>
                        <th>{t('logs.user')}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {logsList.map((log: any) => {
                        const createdAt = new Date(log.date).toDateString() || '-';
                        return (
                          <>
                            <tr key={log._id}>
                              <td>{createdAt}</td>
                              <td>
                                <p className={styles.logHeader}>{log.actionSummary}</p>
                              </td>
                              <td title={log?.detailedInfo}>{log.detailedInfo?.length > 100 ? `${log.detailedInfo?.substring(0, 100)}...` : log.detailedInfo}</td>
                              <td>{log.doneByUserId?.email ?? log.guestUserEmail}</td>
                            </tr>
                          </>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
                {/*Table*/}
                {/*Pagination*/}
                <Pagination onPrevious={onPrevious} onNext={onNext} currentPage={page} totalPages={totalPages} />
                {/*Pagination*/}
              </div>
            </div>
          ) : (
            <h1>{t('logs.noLogsFounds')}</h1>
          )
        ) : (
          <h1>{t('logs.noPermission')}</h1>
        )}
      </div>
    </main>
  );
};

export default LogsPage;
